const convertToSnakeCase = (text) => {
  text = text.trim();
  text = text.toLowerCase().replace(/ /g, "_") + "_pg";
  return text;
};

export default convertToSnakeCase;
